import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-start gap-12 lg:gap-16">
          <div className="flex-1 lg:max-w-[45%]">
            <span className="inline-block px-3 py-1 mb-5 text-xs font-medium text-foreground-500 border border-background-300/60 rounded-full">
              About
            </span>

            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 mb-2 leading-tight">
              Why CSSBuy Spreadsheet
            </h2>
            <p className="text-2xl md:text-3xl font-heading text-foreground-400 italic mb-8">
              Trusted by Thousands
            </p>

            <div className="space-y-5 text-sm md:text-base text-foreground-600 leading-relaxed">
              <p>
                Navigating the vast world of CSSBuy spreadsheets can be overwhelming. With thousands of products spread across dozens of categories, finding the right items at the right quality level requires time, experience, and a reliable source of information.
              </p>
              <p>
                That is exactly why we built <strong className="text-foreground-900">CSSSpreadsheet.study</strong> — a dedicated hub that organizes, curates, and simplifies the CSSBuy spreadsheet experience. Our team of experienced shoppers continuously reviews, verifies, and updates listings to ensure you get only the best finds.
              </p>
              <p>
                Whether you are looking for the latest sneaker drops, premium hoodies, designer accessories, or niche streetwear pieces, our categorized spreadsheet system puts everything at your fingertips. Every listing includes detailed quality check (QC) notes, sizing recommendations, and direct links — saving you hours of manual searching.
              </p>
              <p>
                We believe in transparency: our buying guides are researched and written by real users who have completed hundreds of CSSBuy hauls. No fluff, no sponsored picks — just honest, practical advice for fellow shoppers.
              </p>
            </div>

            <Link
              to="/article/cssbuy-sheet-complete-guide"
              className="inline-flex items-center gap-1.5 mt-8 text-sm font-semibold text-primary-700 hover:text-primary-800 transition-colors cursor-pointer"
            >
              Read the Full CSSBuy Sheet Guide
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
            </Link>
          </div>

          <div className="flex-1 w-full lg:max-w-[55%]">
            <div className="flex justify-end gap-3 mb-6">
              <div className="text-right">
                <div className="text-3xl md:text-4xl font-heading font-bold text-foreground-950">14+</div>
                <div className="text-xs text-foreground-500">Categories</div>
              </div>
              <div className="w-px bg-background-300/60 mx-4"></div>
              <div className="text-right">
                <div className="text-3xl md:text-4xl font-heading font-bold text-primary-600">Daily</div>
                <div className="text-xs text-foreground-500">Updates</div>
              </div>
            </div>

            <div className="flex gap-4">
              <div className="w-[45%]">
                <div className="rounded-xl overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Clean%20modern%20warehouse%20interior%20with%20organized%20shelves%20filled%20with%20fashion%20items%20and%20packages%2C%20warm%20natural%20lighting%20streaming%20through%20windows%2C%20neat%20industrial%20aesthetic%2C%20soft%20cream%20and%20beige%20tones%2C%20editorial%20photography%20style%2C%20no%20text%2C%20minimalist%20composition&width=500&height=500&seq=about-warehouse-01&orientation=squarish"
                    alt="CSSBuy Spreadsheet warehouse product storage"
                    title="CSSBuy Spreadsheet product organization"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
              <div className="w-[55%]">
                <div className="rounded-xl overflow-hidden h-full">
                  <img
                    src="https://readdy.ai/api/search-image?query=Stylish%20product%20unboxing%20flat%20lay%20featuring%20sneakers%20and%20clothing%20items%20artfully%20arranged%20on%20a%20cream%20background%2C%20warm%20soft%20lighting%2C%20lifestyle%20editorial%20photography%2C%20trendy%20minimalist%20aesthetic%2C%20no%20text%2C%20clean%20modern%20composition&width=600&height=750&seq=about-unboxing-02&orientation=portrait"
                    alt="CSSBuy Spreadsheet product unboxing showcase"
                    title="CSSBuy Spreadsheet product showcase"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}